require('./bootstrap');
require('datatables.net');
// var Chart = require('chart.js')